import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie } from 'lucide-react';
import { Button } from '@/components/ui/button';

const STORAGE_KEY = 'florisimo_cookie_consent';

export function CookieConsentBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) {
      // Small delay to avoid flash on page load
      const timer = setTimeout(() => setShowBanner(true), 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setShowBanner(false);
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-xl shadow-[0_-4px_20px_-4px_rgba(0,0,0,0.08)] border-t border-primary/10 rounded-t-2xl"
          dir="rtl"
        >
          <div className="container mx-auto px-4 py-4 md:py-3">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <div className="flex items-start md:items-center gap-3">
                <Cookie className="w-5 h-5 text-primary flex-shrink-0 mt-0.5 md:mt-0" />
                <p className="text-sm text-foreground leading-relaxed">
                  אתר זה משתמש בקבצי Cookie על מנת לשפר את חווית הגלישה ולספק שירות מתקדם. 
                  המשך הגלישה באתר מהווה הסכמה לשימוש זה.
                  {' '}
                  <Link 
                    to="/privacy" 
                    className="text-primary hover:underline font-medium"
                  >
                    למידע נוסף
                  </Link>
                </p>
              </div>
              <Button 
                onClick={handleAccept}
                className="w-full md:w-auto flex-shrink-0"
                size="sm"
              >
                אישור
              </Button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
